<script setup>
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { useI18n } from 'vue-i18n';

import SettingsSection from 'dashboard/components-next/Settings/SettingsSection.vue';
import BuildInfo from './BuildInfo.vue';

const { t } = useI18n();
const { currentAccount } = useAccount();

const getAccountId = computed(() => currentAccount.value?.id?.toString());
</script>

<template>
  <SettingsSection
    :title="t('GENERAL_SETTINGS.FORM.ACCOUNT_ID.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.ACCOUNT_ID.NOTE')"
  >
    <div class="p-4">
      <woot-code :script="getAccountId" />
    </div>
    <BuildInfo />
  </SettingsSection>
</template>
